import { render, staticRenderFns } from "./TenantModal.vue?vue&type=template&id=1869b072&"
import script from "./TenantModal.vue?vue&type=script&lang=js&"
export * from "./TenantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports